<div tid="contact_header" class="contact-header-container">
    <div class="item-profile"><img tid="contact_image" src="./assets/images/noportrait.png" class="img-circle"
            alt="profile"></div>
    <div tid="contact-info" class="item-contact-info h1-light">
        <div class="item-contact-info-elements">
            <div tid="contact_name" class="item-name-value" [style.max-width]="windowSize<=900?'100%':'20%'">{{config.contact.name}}</div>
            <div tid="edit_contact" #tooltip class="edit-icon" *ngIf="canEdit()" kendoTooltip position="bottom"
                tooltipClass="tooltip-adjust-right">
                <smart-icon name="pencil" (click)="editContact()" class="light" title="Edit"></smart-icon>
            </div>
            <div class="contact-basic-information-container title" [style.display]="windowSize<=900?'none':'flex'">
                <div class="basic-information-item" [style.display]="item.display" [style.width]="item.width"
                    *ngFor="let item of basicInformation; trackBy:trackByFn" [attr.tid]="item.title">
                    <div class="item-title">{{item.title}}</div>
                    <div class="item-value" *ngIf="item.value&& item.type === 'Text'" [title]="item.value">{{item.value}}</div>
                    <div class="item-value item-link" *ngIf="item.value&& item.type === 'Entity'"
                        (click)="onEntityClick($event,item.id)" [title]="item.value">{{item.value}}</div>
                    <a class="item-value item-link item-href" *ngIf="item.value&& item.type === 'Email'"
                        href="mailto:{{item.value}}" [title]="item.value">{{item.value}}</a>
                    <div class="item-value" *ngIf="!item.value">&nbsp;</div>
                </div>
            </div>
            <div tid="operation_save" class="operation-box"><button tam-button tamType="primary" tamSize="normal"
                    (click)="onSaveClick()" *ngIf="isPPCUser&&!isIPAD">Publish</button></div>
        </div>
    </div>
</div>